module.exports = __webpack_public_path__ + "static/img/platform.93b8cc4.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/platform.png
// module id = fvJO
// module chunks = 0